import { render, staticRenderFns } from "./FactorBandList.vue?vue&type=template&id=f8ea560a&scoped=true"
import script from "./FactorBandList.vue?vue&type=script&lang=js"
export * from "./FactorBandList.vue?vue&type=script&lang=js"
import style0 from "./FactorBandList.vue?vue&type=style&index=0&id=f8ea560a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8ea560a",
  null
  
)

export default component.exports